import { useState, useEffect } from "react"

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState(null)
  const [hoveredMenuItem, setHoveredMenuItem] = useState(false)
  const [isHoveringTile, setIsHoveringTile] = useState(false)
  const [isHoveringMenu, setIsHoveringMenu] = useState(false)

  // Close context menu when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      setContextMenu(null)
    }
    if (contextMenu) {
      document.addEventListener("click", handleClickOutside)
      return () => document.removeEventListener("click", handleClickOutside)
    }
  }, [contextMenu])

  // Hide context menu when neither tile nor menu is hovered
  useEffect(() => {
    if (contextMenu && !isHoveringTile && !isHoveringMenu) {
      setContextMenu(null)
    }
  }, [contextMenu, isHoveringTile, isHoveringMenu])

  const handleContextMenu = (event, isAssigned) => {
    event.preventDefault()
    event.stopPropagation()
    
    // Only show context menu for assigned tiles
    if (!isAssigned) return
    
    setContextMenu({
      x: event.clientX,
      y: event.clientY,
    })
  }

  const handleOtherTileMouseEnter = () => {
    // Close context menu when hovering any other tile
    if (contextMenu) {
      setContextMenu(null)
      setIsHoveringTile(false)
      setIsHoveringMenu(false)
    }
  }

  // Duplicate tile
  const handleDuplication = (tile, tiles, setTiles) => {
    const duplicateTile = {
      ...tile,
      objectId: crypto.randomUUID(),
      originalId: tile.originalId || tile.objectId,
      theoreticalStartTime: null,
      theoreticalEndTime: null,
      machine: null
    }
    tiles.unshift(duplicateTile)

    setTiles([...tiles])
    setContextMenu(null)
  }

  // Remove only the tile instance that was clicked
  const handleDelete = (tile, tiles, setTiles) => {
    const testTiles = tiles.filter((t) => t.objectId !== tile.objectId)
    setTiles(testTiles)
  }

  return {
    contextMenu,
    hoveredMenuItem,
    setHoveredMenuItem,
    isHoveringTile,
    setIsHoveringTile,
    isHoveringMenu,
    setIsHoveringMenu,
    handleContextMenu,
    handleOtherTileMouseEnter,
    handleDuplication,
    handleDelete
  }
}
